// extracted by mini-css-extract-plugin
export default {"textAlignVerticalCenter":"EditPreDefinedRoute_textAlignVerticalCenter__3d5V-","hidden":"EditPreDefinedRoute_hidden__1_tK5"};